module.exports = __webpack_public_path__ + "static/media/cloud-googledrive-icon.1d9f050e.svg";